import queries from '@apis/queries';
import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import TextField from '@components/TextField';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import GiftOrderContext from '@providers/GiftOrderProvider/GiftOrderContext';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import styles from './styles.module.scss';

interface Props {
    giftCardImageId: string;
}

function CardInfo({ giftCardImageId }:Props) {
  const { state, handleChange } = useContext(GiftOrderContext);
  const { data } = useQuery(queries.prepaidCardImages.detail(giftCardImageId));

  return (
        <Column fullWidth spacing={38}>
            <Wrapper>
                <Container spacing={16} >
                    <CardImage src={data?.imageUrl}
                               width={90}
                               height={60}
                               alt='선불카드 이미지' />
                    <Text size='xl'>{data?.title}</Text>
                </Container>
            </Wrapper>
            <Column className={styles.name}
                    fullWidth
                    spacing={12}>
                <Text size='2xl' fontWeight='bold' color={colors.gray7}>
                    카드이름
                </Text>
                <TextField placeholder='나만의 카드 이름을 입력해주세요'
                           value={state.cardName}
                           onChange={handleChange}
                           name='cardName'
                           maxLength={20}
                           showLength />
                <Text color={colors.gray5} size='s' fontWeight='bold'>
                    카드별명은 구매 후 ‘카드 관리’ 에서도 변경 가능합니다.
                </Text>
            </Column>

        </Column>
  );
}

const Wrapper = styled.section`
    background-color: var(--color-gray2);
    padding: 30px 20px;
    width: 100%;
`;

const Container = styled(Row)`
    background-color: var(--color-white);
    border: 1px solid var(--color-gray3);
    border-radius: 6px;
    padding: 16px;
    img {
        border-radius: 4px;
    }`;

const CardImage = styled(Image)`
    object-fit: cover;
`;

export default CardInfo;
